// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconInvoice = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M9 12.77c.13 1.258.926 2 2.219 2.2v1.27h1.67v-1.29C14.192 14.705 15 13.901 15 12.715c0-1.206-.786-1.746-2.09-2.127l-.861-.254c-.68-.2-1.045-.349-1.045-.825 0-.402.334-.72 1.001-.72.636 0 1.034.307 1.142.89l1.702-.138c-.13-1.09-.83-1.82-1.96-2.053V6.24h-1.67v1.25c-1.282.243-2.025 1.037-2.025 2.127 0 1.238.765 1.767 2.165 2.19l.883.265c.625.19.96.296.96.772 0 .466-.367.826-1.121.826s-1.217-.36-1.336-1.037z" />,
    <path
      fillRule="evenodd"
      d="M19 6h2V3H3v3h2v13.87l1.327 1.548 1.853-1.622 1.891 1.47 1.929-1.5 1.929 1.5 1.89-1.47 1.854 1.622L19 19.87zm-2 12.171l-1.105-.967-1.966 1.53-1.929-1.5-1.929 1.5-1.966-1.53L7 18.171V5h10z"
    />
  );
export default SvgIconInvoice;
